let service = {}

if (process.env.VUE_APP_SERVER_ENV == 'production') {
  service.gateway = 'https://gateway.prod.experiencethis.co'
  service.master_venue = 'https://gateway.prod.experiencethis.co/master-venue'
  service.serverless_api = 'https://6pzvgls42l.execute-api.eu-west-2.amazonaws.com/prod'
} else if (process.env.VUE_APP_SERVER_ENV == 'demo') {
  service.gateway = 'https://gateway.demo.experiencethis.co'
  service.master_venue = 'https://gateway.demo.experiencethis.co/master-venue'
  service.serverless_api = 'https://isk8qd35jf.execute-api.eu-west-2.amazonaws.com/demo'
} else if (process.env.VUE_APP_SERVER_ENV == 'uat') {
  service.gateway = 'https://gateway.uat.experiencethis.co/gateway'
  service.master_venue = 'https://gateway.uat.experiencethis.co/master-venue'
  service.serverless_api = 'https://121cajdx68.execute-api.eu-west-2.amazonaws.com/uat'
} else if (process.env.VUE_APP_SERVER_ENV == 'staging') {
  service.gateway = 'http://api.staging.experiencethis.co:4050/api'
  service.master_venue =
    'http://api.staging.experiencethis.co:4024/master-venue'
} else {
  service.gateway = 'https://gateway.dev.experiencethis.co'
  service.master_venue = 'http://api.dev.experiencethis.co:4024/master-venue'
  service.serverless_api = 'https://voxzut640l.execute-api.eu-west-2.amazonaws.com/dev'
  // Production
  // service.serverless_api = 'https://6pzvgls42l.execute-api.eu-west-2.amazonaws.com/prod'
  // service.gateway = 'https://gateway.prod.experiencethis.co'

  // UAT
  // service.gateway = 'https://gateway.uat.experiencethis.co/gateway'
  // service.serverless_api = 'https://121cajdx68.execute-api.eu-west-2.amazonaws.com/uat'

  // Demo
  // service.serverless_api = 'https://isk8qd35jf.execute-api.eu-west-2.amazonaws.com/demo'
  // service.gateway = 'https://gateway.demo.experiencethis.co'

  // Local
  // service.serverless_api = 'http://localhost:3000'
  // service.gateway = 'http://localhost:4050/api'
}

export default service